// components/Product.jsx
export default function Product() {
  return (
    <section id="product" className="section">
      <h2>Our Products</h2>
      <p>✨ Coming Soon ✨</p>
    </section>
  );
}
